import {
  BUS_42N_PLUG_PANEL_NUMBER,
  DASH_LABELS,
  DASH_TYPES,
  DIGITAL_DASH_CODE,
  DIGITAL_ICU_LEFT_FILE_NAME,
} from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  F: {
    dependency: {
      panelNumber: 'A66-01975-000',
      top: 15,
      left: 17,
      width: 117,
      height: 196,
      zIndex: 5,
    },
  },
  MSF: {
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  ICU: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: '42N Panel-A ICU',
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
    staticOverride: false,
    [DIGITAL_DASH_CODE]: DIGITAL_ICU_LEFT_FILE_NAME,
  },
  ICUC5: {
    label: DASH_LABELS.A_PANEL_ICU,
    partOverride: DIGITAL_ICU_LEFT_FILE_NAME,
    noTooltip: true,
    disableEvents: true,
    partExpected: true,
    noShowPartNumber: true,
  },
  AUPNL: {
    label: DASH_LABELS.AU_PANEL,
    partOverride: 'AU_Panel_42N',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    staticOverride: true,
  },
  AUPPN: {
    label: DASH_LABELS.AU_PANEL,
    partOverride: 'AU_Panel_42N_Integrated_Storage',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    staticOverride: true,
  },
  AGADP: {
    partOverride: '000 446',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AUDSP: {
    partOverride: '000 446',
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AUX,
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
  },
  AGPNL: {
    label: DASH_LABELS.RIGHT_HAND_B_PANEL_AG,
    partOverride: 'AG Panel 42N',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    staticOverride: true,
    '734-023': 'AG Panel 42N-Integrated Storage',
    '734-024': 'AG Panel 42N-Integrated Storage',
    '734-025': 'AG Panel 42N',
  },
  PLTEM: {
    label: 'TEM Panel',
    partOverride: 'TEM Panel',
    noTooltip: true,
    disableEvents: false,
    openListView: true,
    noShowPartNumber: true,
    staticOverride: true,
  },
  'B-B': {
    swapouts: {
      [BUS_42N_PLUG_PANEL_NUMBER]: '42N_BUS_PLUG_PLACEHOLDER',
    },
    dependency: {
      panelNumber: 'TBBC232883',
      top: 19,
      left: 16,
      width: 114,
      height: 203,
      zIndex: 5,
    },
  },
  PD: {
    preferLocationShape: true,
  },
  USB: {
    preferLocationShape: true,
  },
  'S-F': {
    preferLocationShape: true,
  },
}

export const DASH_META = {
  name: DASH_TYPES.DASH_42N_M2_SD,
  // note, it is a bit of a hack to have both AUPNL and AUPPN in the list.
  // since with dbCode 734-024 and 734-025, AUPNL is removed from locations
  // and AUPPN is added to locations, the code doesn't find an AUPNL and skips it.
  // TODO: panels should be generics or possible sub arrays
  panels: ['PLTEM', 'ICU', 'AGPNL', 'AUPNL', 'AUPPN'],
  width: 7500,
  height: 1050,
  panelsStyle: `
    #AUPNL {
      margin-left: 1320px;
      display: block;
    }
    #PLTEM ~ #AUPNL {
      margin-left: 3330px;
      top: -330px;
    }
    #AUPNL .location-AUPNL,
    #AUPNL .location-AUPNL .tooltip-positioner,
    #AUPNL .location-AUPNL .styled-part {
      height: 554px;
    }
    #AUPPN {
      margin-left: 1320px;
      display: block;
    }
    #PLTEM ~ #AUPPN {
      margin-left: 3330px;
      top: -330px;
    }
  `,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {
  F: 'Switch42N',
  QQ: 'Switch42N',
  A: 'Gauge',
  'F-F': 'Overhead_Radio_42N',
  'AC/F-F': 'Overhead_Radio_42N',
}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    PLTEM: {
      id: 'PLTEM',
      label: 'TEM Panel',
      hideAddMsf: true,
      groups: {
        switches: {
          order: 0,
          id: 'switches',
          panel: 'PLTEM',
          label: 'Switches',
          detail: ['B-B'],
        },
      },
    },
    ICU: {
      id: 'ICU',
      label: 'A Panel: ICU',
      hideAddMsf: true,
      groups: {},
    },
    AUDSP: {
      id: 'AUDSP',
      label: 'B Panel: Right Hand Aux',
      groups: {},
    },
    AGPNL: {
      id: 'AGPNL',
      label: 'AG Panel',
      hideAddMsf: true,
      groups: {
        gauges: {
          order: 0,
          id: 'gauges',
          panel: 'AGPNL',
          label: 'Gauges',
          detail: ['A'],
        },
        other: {
          order: 1,
          id: 'other',
          panel: 'AGPNL',
          label: 'Other',
          detail: ['AC', 'T', 'B', 'A-A', 'PD'],
        },
      },
    },
    AUPNL: {
      id: 'AUPNL',
      label: 'AU Panel',
      groups: {
        AU300: {
          order: 0,
          id: 'AU300',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 3',
          detail: ['QQ'], // children detail
        },
        AU400: {
          order: 1,
          id: 'AU400',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 4',
          detail: ['QQ'],
        },
        AU500: {
          order: 2,
          id: 'AU500',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 5',
          detail: ['QQ'],
        },
        AU600: {
          order: 3,
          id: 'AU600',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 6',
          detail: ['QQ'],
        },
        AU700: {
          order: 4,
          id: 'AU700',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 7',
          detail: ['QQ'],
        },
        AU800: {
          order: 5,
          id: 'AU800',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 8',
          detail: ['QQ'],
        },
        AU930: {
          order: 6,
          id: 'AU930',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 9 Left',
          detail: ['QQ'],
        },
        AU900: {
          order: 7,
          id: 'AU900',
          panel: 'AUPNL',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 9 Right',
          detail: ['QQ'],
        },
        AP300: {
          order: 8,
          id: 'AP300',
          panel: 'AUPPN',
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'MSF 1',
          detail: ['QQ'],
        },
        switches: {
          order: 8,
          panel: 'AUPNL',
          label: 'Switches',
          detail: ['B-B', 'F'],
        },
        au_gauges: {
          order: 9,
          id: 'au_gauges',
          panel: 'AUPNL',
          label: 'Aux Gauges',
          detail: ['A'],
        },
        au_other: {
          order: 10,
          id: 'au_other',
          panel: 'AUPNL',
          label: 'Aux Other',
          detail: ['Z', 'USB', 'S-F', 'JG'],
        },
      },
    },
  },
}
